import { Box, Button, RadioGroup, styled, Typography } from "@mui/material";
import { DateCalendar, PickersDay } from "@mui/x-date-pickers";
import pxToRem from "theme/base/pxToRem";
import { dayColor, DayType } from "./const";
import { hexToRgba } from "theme/types/color";

export const DateCalendarCustom = styled(DateCalendar)<{
  isDisabledWeekend?: boolean;
}>(({ theme, isDisabledWeekend }) => ({
  ".MuiDayCalendar": {
    border: "1px soild",
  },
  ".MuiPickersDay-dayOutsideMonth": {
    color: theme.palette.text.textDisable,
  },
  ".MuiDayCalendar-slideTransition": {
    minHeight: "14.5rem !important",
    overflow: "unset",
  },
  ".MuiDayCalendar-weekContainer": {
    margin: 0,
    display: "flex",
    "& .MuiPickersDay-root:nth-child(6)": {
      backgroundColor: isDisabledWeekend ? "#F2F2F299" : "transparent",
    },
    "& .MuiPickersDay-root:nth-child(7)": {
      backgroundColor: "#F2F2F299",
    },
    ".MuiPickersDay-root": {
      flex: 1,
      // pointerEvents: "none",
      // button: {
      //   pointerEvents: "auto",
      // },
    },
    ".Mui-disabled": {
      // display: "none",
      // backgroundColor: "#F2F2F299",
    },
  },
  ".MuiDayCalendar-header": {
    "@media (max-width: 750px)": {
      minWidth: pxToRem(800),
    },
  },
  ".MuiDayCalendar-header .MuiDayCalendar-weekDayLabel": {
    display: "flex",
    justifyContent: "left",
    color: `${theme.palette.text.textPrimary}`,
    fontWeight: theme.typography.fw_regular_400,
    fontSize: `${theme.typography.size.md_16} !important`,
    paddingLeft: pxToRem(12),
    width: "100%",
  },
  ".MuiDayCalendar-monthContainer": {
    border: `1px solid ${theme.palette.colorsBase.blue_8}`,
    borderRadius: pxToRem(8),
    ":first-child": {
      ":first-child": {
        borderLeft: "none",
      },
    },
    "@media (max-width: 750px)": {
      minWidth: pxToRem(800),
      overflowX: "auto",
    },
  },
  ".Mui-selected": {
    backgroundColor: `white !important`,
    color: `${theme.palette.text.textPrimary} !important`,
    border: `1px solid ${theme.palette.colorsBase.blue_8}`,
  },
}));
export const DayContain = styled(PickersDay)<{
  dayType?: DayType;
}>(({ theme }) => ({
  borderLeft: `1px solid ${theme.palette.colorsBase.blue_8}`,
  borderBottom: `1px solid ${theme.palette.colorsBase.blue_8}`,
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.md_16,
  fontWeight: theme.typography.fw_semibold_500,
  width: "auto",
  height: "auto",
  borderRadius: "0%",
  padding: `${pxToRem(10)}`,
  margin: 0,
  minHeight: pxToRem(130),
}));

export const TimeCheckWrapper = styled("div")<{ dayType: DayType }>(
  ({ theme, dayType }) => ({
    display: "flex",
    flexDirection: "column",
    background: dayColor(theme, dayType, "background"),
    borderLeft: `2px solid ${dayColor(theme, dayType, "border")}`,
    borderRadius: `${pxToRem(2)} ${pxToRem(4)} ${pxToRem(4)} ${pxToRem(2)}`,
    alignItems: "left",
    textAlign: "left",
    color: dayColor(theme, dayType, "color"),
    padding: `${pxToRem(8)} ${pxToRem(12)}`,
    fontSize: theme.typography.size.xs_12,
    fontWeight: theme.typography.fw_regular_400,
  })
);

export const DateInfoWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  svg: {
    width: pxToRem(16),
    height: pxToRem(16),
    path: {
      fill: theme.palette.icon.icDefault,
    },
  },
}));

export const DayNoteItem = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.functions.pxToRem(12),
}));

export const DayNoteLabel = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.md_16,
  fontWeight: theme.typography.fw_semibold_500,
  color: theme.palette.text.textSecondary,
}));

export const LeaveType = styled(Box)<{
  hasBorderLeft?: boolean;
  iColor: string;
}>(({ theme, iColor, hasBorderLeft }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: hasBorderLeft
    ? "none"
    : `1px solid ${iColor ?? theme.palette.colorsBase.blue_8}`,
  borderLeft:
    hasBorderLeft && `2px solid ${iColor ?? theme.palette.colorsBase.blue_8}`,
  background: hexToRgba(iColor ?? theme.palette.background.bgBrandPrimary, 0.1),
  padding: `${pxToRem(8)} ${pxToRem(12)}`,
  p: {
    fontSize: theme.typography.size.xs_12,
  },
  borderRadius: hasBorderLeft ? "0px 4px 4px 0px" : "4px",
  gap: pxToRem(8),
}));

export const LeaveTypeOption = styled(RadioGroup)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  maxHeight: 180,
  overflowY: "scroll",
}));

export const ReasonTypeOption = styled(RadioGroup)(({ theme }) => ({
  display: "grid",
}));

export const NoDataWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: pxToRem(12),
  // alignItems: "center",
  width: "100%",
  p: {
    color: theme.palette.text.textPrimary,
    fontSize: theme.typography.size.xs_12,
  },
}));

export const DayWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(8),
  flex: 1,
  justifyItems: "space-between",
  height: "100%",
  position: "relative",
}));

export const DialogActionWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  svg: {
    width: pxToRem(18),
    height: pxToRem(18),
  },
  "button.Mui-disabled": {
    svg: {
      path: {
        fill: theme.palette.icon.icDisable,
      },
    },
  },
}));

export const ButtonTimeLate = styled(Button)<{ selected: boolean }>(
  ({ theme, selected }) => ({
    width: pxToRem(83),
    border: "solid 1px ",
    fontSize: pxToRem(12),
    fontWeight: 400,
    padding: pxToRem(8),
    height: pxToRem(32),
    borderRadius: pxToRem(4),
    background: theme.palette.colorsBase.gray_0,
    "&:hover": {
      background: theme.palette.colorsBase.gray_0,
    },
    ...(selected
      ? {
          borderColor: theme.palette.colorsBase.blue_0,
          color: theme.palette.colorsBase.blue_0,
        }
      : {
          borderColor: theme.palette.colorsBase.blue_8,
          color: theme.palette.colorsBase.gray_10,
        }),
  })
);

export const IconExpand = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: pxToRem(10),
  right: pxToRem(2),
  cursor: "pointer",
  svg: {
    width: pxToRem(16),
    height: pxToRem(16),
    path: {
      fill: theme.palette.icon.icDefault,
    },
  },
}));
